/** Renders one value in a table cell, by field type. */

import type { FieldSchema } from '../api/types'
import { formatTimestampShort, minutesToHhmm, shortenUpn } from '../lib/format'

export function CellValue({ field, value }: { field: FieldSchema | undefined; value: unknown }) {
  if (!field) return <>{value === null || value === undefined ? '—' : String(value)}</>

  switch (field.type) {
    case 'bool':
      return (
        <span className={`badge ${value ? 'badge--on' : 'badge--off'}`}>
          {value ? 'On' : 'Off'}
        </span>
      )
    case 'timestamp':
      return <>{formatTimestampShort(value)}</>
    case 'minute_of_day':
      return <>{value === null || value === undefined ? '—' : minutesToHhmm(value as number)}</>
    case 'enum': {
      const option = field.options.find((o) => o.value === value)
      return <span className="badge badge--info">{option?.label ?? String(value ?? '—')}</span>
    }
    default: {
      if (value === null || value === undefined || value === '') return <>—</>
      if (field.name === 'updated_by') return <>{shortenUpn(value)}</>
      return <>{String(value)}</>
    }
  }
}
